module.exports = __webpack_public_path__ + "3e4ab2e90b3299cb139a0a652e98b692.png";